<e-list header="Live dashboard" separateRight>
  <present-users-filters class="m-2"></present-users-filters>
  <div slot="bottom">
    <hr />
    <h5 class="text-primary m-2">Forceren voor <b>iedereen</b></h5>
    <div class="p-2">
      <button
        featureAccess="forceInvalidateAll"
        (click)="onForceInvalidateAll()"
        class="mb-1"
        block
        eBtn
        color="primary"
        icon="sign-out-alt"
      >
        Afmelden
      </button>
      <button
        featureAccess="forceStopAll"
        (click)="onForceStopAll()"
        block
        eBtn
        color="primary"
        icon="stop-circle"
      >
        Afmelden & afwezig
      </button>
    </div>
  </div>
</e-list>

<present-users-table
  class="dock-y"
  [presentUsers]="presentDeviceUserQueries.all$ | async"
></present-users-table>
